import { stripTags } from "functions/stripTags";
import sourceflowEnums from "@/sourceflow.enums";
import { useMemo } from "react";

export const JobPostingSchema = ({ job, job_type }) => {

  const normalizedAddress = useMemo(() => {
    const p = job?.derived_info?.locations?.[0]?.postal_address;
  
    const streetAddress =
      p?.address_lines?.[0] ??
      job?.location ??
      "Location not specified"
  
    const locality = p?.locality || job?.location || "Not Specified";

    const [localityPart, regionPart] = locality.split(",").map(s => s.trim());
  
    return {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        addressLocality: localityPart,
        addressRegion: regionPart|| "Not Specified",
        addressCountry:
          p?.region_code === "US"
            ? "United States"
            : p?.region_code || "US",
      },
    };
  }, [job]);
 
  // const currency = useMemo(() => {
  //   return (job?.salary_package?.match(
  //     /[$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]/,
  //   ) ?? ["£"])[0];
  // }, [job?.salary_package]);

  const unitText = useMemo(() => {
    const text = job?.salary_package || "";

    const unitMap = {
      annum: "YEAR",
      year: "YEAR",
      month: "MONTH",
      week: "WEEK",
      day: "DAY",
      hour: "HOUR",
      hourly: "HOUR",
      daily: "DAY",
      weekly: "WEEK",
      monthly: "MONTH",
      annually: "YEAR",
    };

    const match = text.match(/per\s+(\w+)/i);

    if (!match) return "YEAR"; // default fallback

    const found = match[1].toLowerCase();

    return unitMap[found] || "YEAR";
  }, [job?.salary_package]);

  const employmentType = useMemo(() => {
    const type = job_type?.toLowerCase() || "";

    if (type.includes("permanent")) return "PERMANENT";
    if (type.includes("temporary")) return "TEMPORARY";

    // fallback if unknown
    return "OTHER";
  }, [job_type]);


  const schemaData = {
    "@context": "https://schema.org/",
    "@type": "JobPosting",
    title: `${job.title}`,
    description: `${stripTags(job.description)}`,
    url: `${sourceflowEnums.seo.baseURL}jobs/${job.url_slug}`,

    identifier: {
      "@type": "PropertyValue",
      name: sourceflowEnums.seo.siteName,

      value: `${job.external_reference}`,
    },
    datePosted: `${job.created_at}`,
    validThrough: `${job.expires_at}`,
    hiringOrganization: {
      "@type": "Organization",
      name: sourceflowEnums.seo.siteName,
      sameAs:  sourceflowEnums.seo.baseURL,
      logo: sourceflowEnums.seo.logo,
    },

    jobLocation: normalizedAddress,
    employmentType: employmentType || "Not Defined",
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: 'USD',
      value: {
        '@type': 'QuantitativeValue',
        value: `${job.salary_package}`,
        unitText: `${unitText}`,
    },
    },
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />;
};

export default JobPostingSchema;
